/**
 * State Model Interface
 * Framework-agnostic TypeScript interface
 */

export interface State {
  state_id?: number;
  id?: number;
  state_name: string;
  state_code: string;
  region_id: number;
  region_name?: string;
  created_at?: string;
  updated_at?: string;
  active?: number | boolean;
  program_id?: number;
}

export interface StateFormData {
  id?: number;
  state_id?: number;
  state_name: string;
  state_code: string;
  region_id: number;
}

export interface StateApiResponse {
  data: {
    state: State[];
  };
  message?: string;
  success?: boolean;
}
